import { createEvent } from 'effector'
import { register } from '~/core/repository'
import { entitiesPlayerTrailerModel } from '~/entities/player/trailer'
import {
  $DOLBY_ATMOS,
  featuresMaxAutoQualityAudioModel,
} from '~/features/max-auto-quality/audio'
import { featuresMaxAutoQualityVideoModel } from '~/features/max-auto-quality/video'

export const init = createEvent()

register(
  featuresMaxAutoQualityVideoModel.selectMaxAutoQualityAuto,
  'settings/video-audio/selectMaxAutoQualityAuto'
)
register(
  featuresMaxAutoQualityVideoModel.selectMaxAutoQualityLow,
  'settings/video-audio/selectMaxAutoQualityLow'
)
register(
  featuresMaxAutoQualityVideoModel.selectMaxAutoQualityMedium,
  'settings/video-audio/selectMaxAutoQualityMedium'
)
register(
  featuresMaxAutoQualityVideoModel.selectMaxAutoQualityHigh,
  'settings/video-audio/selectMaxAutoQualityHigh'
)
register(
  featuresMaxAutoQualityVideoModel.$isMaxAutoQualityAuto,
  '$settings/video-audio/isMaxAutoQualityAuto'
)
register(
  featuresMaxAutoQualityVideoModel.$isMaxAutoQualityLow,
  '$settings/video-audio/isMaxAutoQualityLow'
)
register(
  featuresMaxAutoQualityVideoModel.$isMaxAutoQualityMedium,
  '$settings/video-audio/isMaxAutoQualityMedium'
)
register(
  featuresMaxAutoQualityVideoModel.$isMaxAutoQualityHigh,
  '$settings/video-audio/isMaxAutoQualityHigh'
)
register(
  featuresMaxAutoQualityAudioModel.setIsDolbyAtmosPreferred,
  'settings/video-audio/setIsDolbyAtmosPreferred'
)
register(
  featuresMaxAutoQualityAudioModel.$currentDolbyAtmosPreferred,
  '$settings/video-audio/currentDolbyAtmosPreferred'
)
register($DOLBY_ATMOS, '$settings/video-audio/dolbyAtmos')
register(
  entitiesPlayerTrailerModel.setIsAutoPlayTrailers,
  'settings/video-audio/setIsAutoPlayTrailers'
)
register(
  entitiesPlayerTrailerModel.$currentAutoPlayTrilers,
  '$settings/video-audio/currentAutoPlayTrilers'
)
register(
  entitiesPlayerTrailerModel.$enabled,
  '$settings/video-audio/isAutoPlayTrilersEnabled'
)
